import { useNavigate, useLocation, } from "react-router-dom";
import "./PostingLimit.css";
import { useTranslation } from "react-i18next";
import { auth } from "../firebase";

export default function PostingLimit() {
  const navigate = useNavigate();
  const location = useLocation();  

 const { t } = useTranslation();

  const listingId = location.state?.listingId;

  const handleBuyListing = async () => {

    if (!listingId) {
      alert(t("postingLimit.missingListingId"));
      return;
    }

    const res = await fetch(
      "https://vipart-backend.onrender.com/create-payment",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "extra_listing",
          userId: auth.currentUser.uid,
          listingId,
        }),
      }
    );

    const data = await res.json();

    if (data.paymentUrl) {
      window.location.href = data.paymentUrl;
    }
  };



  return (
    <div className="posting-limit-page">

      <h1>{t("postingLimit.title")}</h1>

      <p className="limit-subtitle">
  {t("postingLimit.subtitle")}
</p>

      {/* Unlimited */}
      <div className="limit-card">
  <h2>{t("postingLimit.unlimitedTitle")}</h2>

  <p className="price">25₾ / {t("postingLimit.month")}</p>

  <p className="description">
  {t("postingLimit.unlimitedDescription")}
</p>

  <button
    onClick={async () => {
      const res = await fetch(
        "https://vipart-backend.onrender.com/create-payment",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "limitless",
            userId: auth.currentUser.uid,
            listingId,
          }),
        }
      );

      const data = await res.json();

      if (data.paymentUrl) {
        window.location.href = data.paymentUrl;
      }
    }}
  >
    {t("postingLimit.startUnlimited")}
  </button>
</div>




      <div className="limit-card">
  <h2>{t("postingLimit.singleTitle")}</h2>

  <p className="price">3₾</p>

  <p className="description">
  {t("postingLimit.singleDescription")}
</p>



  <button onClick={handleBuyListing}>
    {t("postingLimit.buyListing")}
  </button>
</div>
    </div>
  );
}
